import { api } from '@api/api2';
import type { TypesPayload } from '../interfaces';

const getTypesList = (payload: TypesPayload) =>
  api.v4('get', 'ticket/types/list', payload);

export const typesApi = {
  getTypesList,
};
